import React from 'react';
import classes from './landingCooperation.module.css';

const testimonials = [
  {
    title: 'مادة اللغة العربية',
    name: 'أم غازي',
    description:
      'وربي موعارفه اشكركم، اولادي كانوا يحتاجون احد غيري يدرسهم ، انا يتدلعون عليا لكن مع فهيم وتواصلهم مع شخص غيري يستحون ويسمعون الكلام ويركزون وغازي راح المدرسة واذهل الأستاذ في الصف يقول ممتاز، والله اني ادعي لكم من كل قلبي',
    id: 1,
  },
  {
    title: 'مادة المهارات الرقمية',
    name: 'أبو خالد',
    description:
      'الحمدلله ابنائي الثلاثة على مختلف مراحلهم قدرت اعتمد على فهيم بشكل كبير في دراستهم وكنت اتابعهم وانا في العمل مع معلمينهم في منصة فهيم  اللي شالت عنا حمل كبير',
    id: 2,
  },
  {
    title: 'مادة القرآن الكريم',
    name: 'أم حليمة',
    description:
      'بنتي عندها صعوبة في التعلم والنطق وكانت تعاني من هالشي في دراستها والان مع منصة فهيم تغير مستواها وصارت مبسوطة مرة ومن الاوائل في الفصل. الله يسعدكم مثل ما اسعدتونا',
    id: 3,
  },
];

const TestimonialsSection = () => {
  return (
    <section className={classes['testimonials-section']}>
      <div className={classes['testimonials-small-container']}>
        <h3>آراء العملاء</h3>
        <div className={classes['testimonials-column']}>
          <div className={classes['testimonials-wrapper']}>
            <div className={classes['testimonials']}>
              {testimonials.map((testimonial) => (
                <div
                  className={classes['testimonial-card']}
                  key={testimonial.id}
                >
                  <div className={classes['testimonial-title']}>
                    <h5>
                      <sup>
                        <i className="fas fa-quote-right ml-2"></i>
                      </sup>
                      {testimonial.description}
                      <sub>
                        <i className="fas fa-quote-left mr-2"></i>
                      </sub>
                    </h5>
                    <p>- {testimonial.name}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
